import { render, staticRenderFns } from "./SectionSettingDialog.vue?vue&type=template&id=5de2187a&scoped=true"
import script from "./SectionSettingDialog.vue?vue&type=script&lang=js"
export * from "./SectionSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SectionSettingDialog.vue?vue&type=style&index=0&id=5de2187a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de2187a",
  null
  
)

export default component.exports